import { TimeUnit } from "@models/enums/time-unit.enum";
import { ValueUnit } from "@models/enums/value-unit.enum";

export class RevisionUtils {

    static computeRevisionTime(type: ValueUnit, value: any, unit: TimeUnit) {
        if (value !== undefined && type === ValueUnit.Time) {
            switch (unit) {
                case TimeUnit.MINUTES:
                    return value;
                case TimeUnit.HOURS:
                    return (value / 60).toFixed(2);
                case TimeUnit.DAYS:
                    return (value / 1440).toFixed(2);
                case TimeUnit.WEEKS:
                    return (value / 10080).toFixed(2);
                case TimeUnit.MONTHS:
                    return (value / 43800).toFixed(2);
            }
        }
        return value;
    }
}
